export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BRAND = {
    name: "Meraki Riders Group",
    short: "Meraki Riders",
    founded: 2021,
    location: "Delhi NCR",
    logo: "https://customer-assets.emergentagent.com/job_community-rides-7/artifacts/27njzh43_Meraki%20Riders%20Group%20-%20Logo%28black%20bg%29.png",
    instagram: "https://instagram.com/merakiriders",
    facebook: "https://www.facebook.com/merakiridersgroup",
    webapp: "https://merakiriders.in",
    looker: "https://datastudio.google.com/reporting/15cf17ce-443c-4d65-8718-15bcc61ef107/page/MiNQF",
    lookerEmbed: "https://datastudio.google.com/embed/reporting/15cf17ce-443c-4d65-8718-15bcc61ef107/page/MiNQF",
    hashtags: ["#merakiriders", "#merakiriderscommunity"],
};

export const IMG = {
    hero: "https://static.prod-images.emergentagent.com/jobs/fc8c9157-432f-4faf-95e8-7e7ab6e060ec/images/0968b56fe79e0b866b2bb3c75d1e3f443cfcebb3e363f26479479d197eee4c7c.png",
    goldTexture: "https://static.prod-images.emergentagent.com/jobs/fc8c9157-432f-4faf-95e8-7e7ab6e060ec/images/76427dd3f3d5320eb814354f83744da2933b81676bc9efa4e6fe6cce42be5c94.png",
    leather: "https://static.prod-images.emergentagent.com/jobs/fc8c9157-432f-4faf-95e8-7e7ab6e060ec/images/71443231ff359ed155dff1f3a48d8357393f73e070622173f81b435fd3a056d0.png",
    engine: "https://static.prod-images.emergentagent.com/jobs/fc8c9157-432f-4faf-95e8-7e7ab6e060ec/images/44d2a0302751af698c342801c75646c8cc0a48d27bbb2704866e29f86bed7cae.png",
    community: [
        "https://images.unsplash.com/photo-1590506978404-d3e577192a18?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
        "https://images.unsplash.com/photo-1558980664-2cd663cf8dde?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
        "https://images.unsplash.com/photo-1606927131353-c0ad17d60b56?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    ],
};
